import { contentViewedEvent, leadSubmittedEvent } from "../lib/analytics";

export const trackContentViewed = () => {
  return () => contentViewedEvent();
};

export const trackLeadSubmitted = () => {
  return () => leadSubmittedEvent();
};
